<template>
  <div class="demo-wrap theme-light">
    <div
      style="
        padding-right: 60px;
        width: 100%;
        height: 100%;
        overflow-y: auto;
        box-sizing: border-box;
        display: flex;
      ">
      <iframe
        ref="iframe"
        :src="url"
        allow="camera *;microphone;display-capture;clipboard-write;"
        style="width: 100%; height: 100%; border: 0"></iframe>
    </div>
    <div
      id="otm-container-monitoring"
      ref="otm-frame-container"
      class="frame-active frame-toggle open">
      <div class="otm-wrap monitoring">
        <nav class="sidebar">
          <ul class="menu-ul">
            <li id="menu-toggle">
              <a
                href="javascript:void(0);"
                class="menu menu-toggle"
                @click.prevent="toggleMenu">
                <span>{{ $t('monitoring.menu.hide') }}</span></a
              >
            </li>
            <li id="menu-front" ref="menu-front">
              <a
                href="javascript:void(0);"
                class="menu menu-front"
                @click.prevent="toggleMenu">
                <span>{{ $t('monitoring.menu.frontal') }}</span>
              </a>
            </li>
            <li id="menu-chat" ref="menu-chat">
              <a
                href="javascript:void(0);"
                class="menu menu-chat"
                @click.prevent="toggleMenu">
              </a>
            </li>
          </ul>
        </nav>
        <div class="monitoring-inner">
          <div class="otm-header">
            <h1 class="h1-text">{{ $t('demo.demoExamRoom.monitoring') }}</h1>
          </div>
          <div class="otm-body">
            <div class="otm-body-inner">
              <!-- section video -->
              <div class="connection-wrap section">
                <!-- 정면 -->
                <div
                  class="item item-front line-bottom connected"
                  ref="item-front">
                  <div class="tit-box between">
                    <h2>{{ $t('demo.demoExamRoom.front') }}</h2>
                    <span class="icon icon-text ing-rec">REC</span>
                  </div>
                  <div class="connection-box">
                    <!-- 연결 후 -->
                    <div class="after">
                      <div class="video-box">
                        <canvas ref="canvas" style="display: none" />
                        <video
                          ref="video_self"
                          autoplay
                          width="100%"
                          height="100%"
                          @play="playVideo"></video>
                      </div>
                    </div>
                    <!-- //연결 후 -->
                  </div>
                  <!-- 발생이벤트 -->
                  <div class="event-wrap">
                    <!-- 데이터 없음 표시 -->
                    <div class="no-data" v-if="logDetectList.length === 0">
                      <div class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                      <div class="text">{{ $t('demo.demoExamRoom.ai') }}</div>
                    </div>
                    <div
                      class="list-group history-list list-group-flush"
                      v-else
                      ref="eventList">
                      <div
                        class="list-group-item"
                        v-for="(log, index) in logDetectList"
                        :key="index">
                        <div class="row">
                          <div
                            class="text-code status-dot col-auto"
                            :class="getStatusClass(log.status)">
                            <span>{{ statusName(log.status) }}</span>
                          </div>
                          <div class="info-date col-auto">
                            <span>{{ log.created | yearToSecond }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- //정면 -->
              </div>
              <!-- //section video -->
              <!-- 채팅 -->
              <div
                class="chat-wrap section line-bottom new-chat"
                ref="item-chat">
                <div class="tit-box">
                  <h2>{{ $t('demo.demoExamRoom.chatting') }}</h2>
                </div>
                <div class="chat-inner">
                  <div class="inner">
                    <div class="chat-cant">
                      <i18n
                        tag="div"
                        class="inner-text"
                        path="demo.demoExamRoom.noChat">
                        <template #br>
                          <br />
                        </template>
                      </i18n>
                    </div>
                    <div class="chat-messages"></div>
                    <div class="chat-input-box">
                      <input
                        type="text"
                        :placeholder="$t('demo.demoExamRoom.msg')" />
                      <button type="button" class="btn-send">
                        <span class="blind">{{
                          $t('demo.demoExamRoom.send')
                        }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- //채팅 -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import '@/assets/scss/demo.scss';
  import {getParameterByName} from '@/js/common/util';
  import {
    checkPermissionDevice,
    getStream,
    captureImage,
    stopLocalCam,
  } from '@/js/utils/camera';
  import Mediapipe from '@/js/video/media_pipe';
  import {
    CUSTOM_COMPANIES,
    VIDEO_SIZE,
    EVENT_SEND_TYPE,
  } from '@/js/common/constants';
  import api from '@/api';
  import initDialogs from '@/components/modal/modalDemoTemplate';

  export default {
    name: 'OtmUserV3ExamRoomDemo',
    metaInfo() {
      return {
        title: this.$t('demo.title'),
      };
    },

    data() {
      return {
        conf: {tmr: null, tmr1: 100, tmr2: 2000},
        det_img: {timestamp: null, dets: [], image: null, sts: null},
        prevDetectLog: {timestamp: new Date().getTime(), status: 'init'},
        dets: null,
        userId: getParameterByName('userid'),
        logDetectInterval: null,
        userInfo: null,
        logDetectList: [],
        url: null,
        mediapipeLoaded: false,
        sendLocalCamImageIntervalId: null,
      };
    },

    async created() {
      initDialogs.call(this, this.onClear);
      const userInfo = await api.userDetail(this.userId);
      this.userInfo = userInfo.data;

      const logo = await this.getCompany(this.userInfo.companyId);
      this.favicon(logo);

      const queryParams = new URLSearchParams(location.search);
      const companyId = queryParams.get('cid') || null;
      if (companyId == CUSTOM_COMPANIES.GTELP_KOREA) {
        this.url = 'https://ibt.g-telp.com/login/applicant' + location.search;
        return;
      } else if (companyId == CUSTOM_COMPANIES.GTELP_GLOBAL) {
        this.url =
          'https://athome.g-telp.com/login/applicant' + location.search;
        return;
      }

      this.url = 'https://select-test.co.kr/user/testFaceQuestionDemo';
    },

    async mounted() {
      if (!this.userId) {
        this.showModal(null, this.$t('error.requiredParamNotFound'));
        this.hideModal(null);
        return;
      }

      const check = await checkPermissionDevice(
        false,
        this.userId,
        'request@metsakuur.com',
      );
      if (!check) return;

      this.loadMediapipe(this.userId);
      this.logDetectInterval = setInterval(() => {
        this.getLogDetect(this.userInfo);
      }, 5000);
    },

    methods: {
      async getCompany(id) {
        try {
          const companyInfo = await api.getCompanyLogo(id);
          return companyInfo.data.icon;
        } catch (error) {
          return require('./../../assets/images/icon/h1-logo.png');
        }
      },
      loadMediapipe(userId) {
        this.mediapipe = new Mediapipe({
          page: 'demo',
          drawUse: false,
          videoRef: this.$refs['video_self'],
          width: VIDEO_SIZE.WIDTH,
          height: VIDEO_SIZE.HEIGHT,
          userId: userId,
          allStopLiveDetect: this.allStopSocketServer,
          contrackLink: 'request@metsakuur.com',
          detectTab: false,
          audio: false,
          successModelLoad: () => {
            this.mediapipeLoaded = true;
          },
          failModelLoad: () => {
            this.mediapipeLoaded = false;
            this.openLocalCam();
          },
        });
      },

      async openLocalCam() {
        try {
          const {stream} = await getStream(this.userId);

          const video = this.$refs['video_self'];
          video.srcObject = stream;

          video.addEventListener('loadedmetadata', () => {
            video.play();
          });
        } catch (error) {
          console.error('openLocalCam'.error);
        }
      },

      playVideo() {
        this.mediapipeLoaded
          ? this.mediapipe.changeDetectStatus(true)
          : (this.sendLocalCamImageIntervalId = setInterval(() => {
              this.sendLocalCamImage();
            }, 3 * 1000));
      },

      sendLocalCamImage() {
        const video = this.$refs['video_self'];
        const canvas = this.$refs['canvas'];
        const image = captureImage(video, canvas);

        const isEmptyDataURL = image.startsWith('data:,');
        if (isEmptyDataURL) return;

        this.sendDetectEvent(image);
      },

      sendDetectEvent(image) {
        const params = {
          timestamp: Date.now(),
          dets: [],
          image: image,
          cnt: 0,
          length: 0,
          sendType: EVENT_SEND_TYPE.DETECTED,
        };

        this.mediapipe.sendDetect(params);
      },

      // 이벤트 로그 확인
      getLogDetect(user) {
        api.getLogDetectList(user.examPeriodId, user.id).then(response => {
          this.logDetectList = [];
          if (response.data.length > 0) {
            this.logDetectList = response.data;
          }
        });
      },
      getStatusClass(status) {
        let className = '';
        switch (status) {
          case 'multi':
            className = 'multi';
            break;
          case 'mismatch':
            className = 'mismatch';
            break;
          case 'notExist':
            className = 'leaving';
            break;
          default:
            break;
        }
        return className;
      },

      statusName(status) {
        let name = '';
        switch (status) {
          case 'multi':
            name = this.$t('demo.demoExamRoom.detect.multi');
            break;
          case 'mismatch':
            name = this.$t('demo.demoExamRoom.detect.ng');
            break;
          case 'notExist':
            name = this.$t('demo.demoExamRoom.detect.leaving');
            break;
          default:
            break;
        }
        return name;
      },

      onClear() {
        clearInterval(this.logDetectInterval);
        clearInterval(this.sendLocalCamImageIntervalId);
        this.mediapipeLoaded
          ? this.mediapipe.stopVideo()
          : stopLocalCam(this.$refs['video_self']);
      },

      onDemoEnd() {
        this.toggleModal('#modal-end-first', true);
      },

      toggleMenu() {
        const container = this.$refs['otm-frame-container'];
        const isOpened = document
          .querySelector('html')
          .classList.contains('menu-open');
        container.classList.add(isOpened ? 'close' : 'open');
        container.classList.remove(isOpened ? 'open' : 'close');
        this.toggleMenuText(isOpened);
      },

      toggleMenuText(status) {
        const toggleMenu = document.querySelector('.menu-toggle span');
        if (toggleMenu) {
          toggleMenu.textContent = status
            ? this.$t('monitoring.menu.open')
            : this.$t('monitoring.menu.hide');
        }
      },

      toggleModal(modalId, flag) {
        const modal = document.querySelector(modalId);
        if (modal) {
          modal.style.display = flag ? 'block' : 'none';
        }
      },

      resizeViewport() {
        const itemFrontHeight = this.$refs['item-front'].offsetHeight;
        this.$refs['menu-front'].style.height = itemFrontHeight + 'px';

        const itemUserHeight = this.$refs['item-chat'].offsetHeight;
        this.$refs['menu-chat'].style.height = itemUserHeight + 'px';
      },
    },
  };
</script>
